/* eslint-disable react/require-default-props */
import React from 'react';
import {FlatList, Platform, RefreshControl, View} from 'react-native';
import {connect} from 'react-redux';
import {isEmpty, noop} from 'lodash';
import {isNil} from 'lodash';
import {constant} from 'lodash/fp';
import {RootState} from 'redux/reducer';

import LoadingIndicator from '/component/base/LoadingIndicator';
import PersonFullName from '/component/partial/report/PersonFullName';
import {Footer} from '/component/partial/report/ReportDataProvider/Footer';
import ReportDefaultLoading from '/component/partial/report/ReportDefaultLoading';
import ReportEmptyState from '/component/partial/report/ReportEmptyState';
import WatchlistEmptyState from '/component/screen/report/MyTeamsReport/WatchlistEmptyState';
import {isViewTeamState} from '/redux/selector/myTeams.selector';
import {black} from '/theme/color/on.color';

import {styles} from './PeopleReportDataRenderer.style';
import {PeopleReportListItem} from './PeopleReportListItem';
import {getKeyExtractor, onRefresh} from './PeopleReportListItem.util';

export function getRenderItem({
  alternateItemKey,
  personIsCoach,
  PersonNameComponent,
  PersonRoleComponent,
  PersonInfoComponent,
  CandidateDispositionInfo,
  NewLabelComponent,
  reportName,
  clientMilestone,
  onRecordPress,
  hasHorizontalPadding,
  isPeopleToContactSection,
  isCandidateReport,
  screenName,
  hideAvatar,
  isCenterAlignedEvenlySpaced,
  AcceptByComponent,
  AcceptByIconComponent,
  isCABReport,
  isCSBReport,
  PersonBonusIndicatorComponent,
  tierName,
  lastPaidRank,
  downlineCoachIds,
  reportData,
  filtersData,
  reportParams,
  fetchMoreReport,
  resetMyTeamsData,
  fetchReport,
  coachCurrentRank,
  coachHighestRank,
  count,
  reportMeta,
  hasReportData,
  loadMore,
  coachId,
  previousScreenName,
  currentScreenName,
  onFocus = noop,
  totalCount,
  renderNameElementDirectly,
  renderRoleElementDirectly,
}: any) {
  return ({item, index}: any) => {
    // if (!isViewTeam || reportName !== 'MY_TEAMS') {
    return (
      <PeopleReportListItem
        fetchReport={fetchReport}
        resetMyTeamsData={resetMyTeamsData}
        fetchMoreReport={fetchMoreReport}
        reportParams={reportParams}
        filtersData={filtersData}
        reportData={reportData}
        hasReportData={hasReportData}
        reportMeta={reportMeta}
        downlineCoachIds={downlineCoachIds}
        hideAvatar={hideAvatar}
        alternateItemKey={alternateItemKey}
        personIsCoach={personIsCoach}
        PersonNameComponent={PersonNameComponent}
        PersonRoleComponent={PersonRoleComponent}
        PersonInfoComponent={PersonInfoComponent}
        CandidateDispositionInfo={CandidateDispositionInfo}
        AcceptByIconComponent={AcceptByIconComponent}
        AcceptByComponent={AcceptByComponent}
        NewLabelComponent={NewLabelComponent}
        PersonBonusIndicatorComponent={PersonBonusIndicatorComponent}
        reportName={reportName}
        onRecordPress={onRecordPress}
        item={item}
        index={index}
        hasHorizontalPadding={hasHorizontalPadding}
        isPeopleToContactSection={isPeopleToContactSection}
        isCandidateReport={isCandidateReport}
        screenName={screenName}
        clientMilestone={clientMilestone}
        isCenterAlignedEvenlySpaced={isCenterAlignedEvenlySpaced}
        isCABReport={isCABReport}
        isCSBReport={isCSBReport}
        tierName={tierName}
        coachId={coachId}
        lastPaidRank={lastPaidRank}
        coachCurrentRank={coachCurrentRank}
        coachHighestRank={coachHighestRank}
        count={count}
        loadMore={loadMore}
        previousScreenName={previousScreenName}
        currentScreenName={currentScreenName}
        onFocus={() => onFocus(index)}
        totalCount={totalCount}
        renderNameElementDirectly={renderNameElementDirectly}
        renderRoleElementDirectly={renderRoleElementDirectly}
      />
    );
  };
}

type OwnProps = {
  alternateItemKey?: string | null;
  reportParams?: any;
  reportData?: any[] | null;
  hasReportData?: boolean;
  reportIsLoading?: boolean;
  reportName?: string;
  count?: number;
  downlineCoachIds?: string[];
  tierName?: string;
  clientMilestone?: string;
  loadingData?: any;
  filtersData?: any;
  fetchReport?: () => void;
  fetchUpdatedReport?: () => void;
  personNameComponent?: React.ElementType;
  personRoleComponent?: React.ElementType;
  personInfoComponent?: React.ElementType;
  CandidateDispositionInfo?: React.ElementType | null;
  NewLabelComponent?: React.ElementType | null;
  loadingComponent?: React.ElementType | null;
  personIsCoach?: () => boolean;
  onRecordPress?: (record?: any) => void;
  fetchMoreReport?: () => void;
  isPeopleToContactSection?: boolean;
  screenName?: string;
  reportMeta?: any;
  hideAvatar?: boolean;
  lastPaidRank?: string;
  isCandidateReport?: boolean;
  isCenterAlignedEvenlySpaced?: boolean;
  AcceptByComponent?: React.ElementType | null;
  AcceptByIconComponent?: React.ElementType | null;
  resetCandidatesData?: () => void;
  isCABReport?: boolean;
  isCSBReport?: boolean;
  PersonBonusIndicatorComponent?: React.ElementType | null;
  resetMyTeamsData?: () => void;
  loadMore?: (() => void) | Record<string, unknown>;
  coachCurrentRank?: string;
  coachHighestRank?: string;
  viewTeamsData?: any[];
  coachId?: string;
  accessible?: boolean;
  isFocused?: boolean;
  renderNameElementDirectly?: boolean;
  renderRoleElementDirectly?: boolean;
};

const mapStateToProps = (state: RootState) => ({
  screenContext: state?.myTeams?.screenContext ?? '',
  tabsValue: state.myTeams.selectedTab,
  isViewTeam: isViewTeamState(state),
});
type ReduxProps = ReturnType<typeof mapStateToProps>;
type Props = OwnProps & ReduxProps;
export class PeopleReportDataRenderer extends React.PureComponent<Props> {
  private onEndReachedCalledDuringMomentum = false;

  state = {
    isRefreshing: false,
  };

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    const {hasReportData, fetchReport} = this.props;

    if (!hasReportData) {
      setTimeout(fetchReport);
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: any) {
    const {hasReportData: hadReportData, filtersData: prevFilters} = prevProps;
    const {
      hasReportData,
      fetchUpdatedReport,
      fetchReport,
      filtersData,
      tabsValue,
      reportData,
      isFocused,
      reportIsLoading,
    } = this.props;

    if (isFocused === false) return;
    const filtersChanged =
      JSON.stringify(prevFilters) !== JSON.stringify(filtersData);
    const tabsChanged = prevProps.tabsValue !== tabsValue;
    // Only trigger if filters actually changed AND different from last applied
    if (filtersChanged || tabsChanged) {
      this.onEndReachedCalledDuringMomentum = true; // Block duplicate loading during transition
      this.setState({isRefreshing: true});
      fetchUpdatedReport();
      return;
    }

    if (prevProps.reportData !== reportData) {
      this.onEndReachedCalledDuringMomentum = true;
      this.setState({isRefreshing: false});
    }

    if (prevProps.reportIsLoading && !reportIsLoading) {
      this.setState({isRefreshing: false});
    }

    // If report data disappeared, re-fetch
    if (hadReportData && !hasReportData) {
      setTimeout(fetchReport);
    }
  }

  refreshing = false;

  flatListRef = React.createRef<FlatList<any>>();

  scrollToIndex = (index: number) => {
    if (this.flatListRef.current) {
      this.flatListRef.current.scrollToIndex({
        animated: true,
        index,
        viewPosition: 0.5, // 0.5 centers the item in the view
      });
    }
  };

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {
      alternateItemKey,
      reportIsLoading = true,
      hasReportData = false,
      reportData = null,
      reportName = '',
      tierName = '',
      downlineCoachIds = [],
      clientMilestone = '',
      loadingData = null,
      personNameComponent: PersonNameComponent = PersonFullName,
      personRoleComponent: PersonRoleComponent = constant(null),
      personInfoComponent: PersonInfoComponent = constant(null),
      CandidateDispositionInfo = null,
      NewLabelComponent = null,
      AcceptByComponent = constant(null),
      AcceptByIconComponent = constant(null),
      PersonBonusIndicatorComponent = constant(null),
      personIsCoach = constant(false),
      onRecordPress = noop,
      fetchMoreReport = noop,
      fetchReport = noop,
      filtersData = null,
      isPeopleToContactSection = false,
      screenName = '',
      reportMeta = null,
      hideAvatar = false,
      lastPaidRank = '',
      isCandidateReport = false,
      isCenterAlignedEvenlySpaced = false,
      resetCandidatesData = noop,
      resetMyTeamsData = noop,
      isCABReport = false,
      isCSBReport = false,
      loadMore = {},
      coachCurrentRank = '',
      coachHighestRank = '',
      count = 0,
      viewTeamsData = [],
      coachId = '',
      reportParams = {},
      tabsValue,
      isViewTeam,
      renderNameElementDirectly = false,
      renderRoleElementDirectly = false,
    } = this.props;

    const {isRefreshing} = this.state;

    // Show loading while waiting for the API response. Here using reportMeta from previously fetched state of the report while waiting for updated response
    const getFlatListData = () => {
      if (reportName === 'MY_TEAMS' && !isViewTeam) {
        return reportData && reportData.length > 0
          ? reportData.slice(0, 1)
          : [];
      }

      if (isViewTeam) {
        if (viewTeamsData && viewTeamsData.length > 0) {
          return viewTeamsData.slice(0, 1);
        }
        if (tabsValue === 'watchlist') {
          return reportData && reportData.length > 0
            ? reportData.slice(0, 1)
            : [];
        }
        return [];
      }

      return reportData || [];
    };

    if (
      (isRefreshing ||
        reportIsLoading ||
        (!hasReportData && reportMeta?.page?.total !== '0')) &&
      !isViewTeam &&
      (!this.onEndReachedCalledDuringMomentum || isRefreshing)
    ) {
      if (!isNil(loadingData)) {
        return (
          <ReportDefaultLoading {...loadingData} isCSBReport={isCSBReport} />
        );
      }
      return (
        // @ts-expect-error TS(2339): Property 'loading' does not exist on type '{ base:... Remove this comment to see the full error message
        <View style={styles.loading}>
          <LoadingIndicator size="large" />
        </View>
      );
    }
    const prevScreen = this.props.loadingData?.previousScreenName;
    const currentScreen = this.props.screenContext;

    const flatListData = getFlatListData();
    const isInitialLoading = reportIsLoading && flatListData.length === 0;

    return (
      <View style={styles.base}>
        {isInitialLoading ? (
          <ReportDefaultLoading {...loadingData} />
        ) : !isEmpty(getFlatListData()) ? (
          <FlatList
            ref={this.flatListRef}
            testID="flatList"
            refreshControl={
              isCandidateReport ? (
                <RefreshControl
                  tintColor={black}
                  refreshing={this.refreshing}
                  onRefresh={() =>
                    onRefresh(this.refreshing, resetCandidatesData)
                  }
                />
              ) : null
            }
            onEndReachedThreshold={isCandidateReport ? 0.1 : 0.5}
            initialNumToRender={10}
            scrollIndicatorInsets={styles.scrollIndicatorInsets}
            viewabilityConfig={{
              viewAreaCoveragePercentThreshold: 95,
            }}
            data={getFlatListData()}
            keyExtractor={getKeyExtractor({alternateItemKey})}
            keyboardShouldPersistTaps="handled"
            renderItem={getRenderItem({
              alternateItemKey,
              personIsCoach,
              PersonNameComponent,
              PersonRoleComponent,
              PersonInfoComponent,
              CandidateDispositionInfo,
              NewLabelComponent,
              AcceptByComponent,
              AcceptByIconComponent,
              reportName,
              clientMilestone,
              onRecordPress,
              hasHorizontalPadding: true,
              isPeopleToContactSection,
              isCandidateReport,
              screenName,
              hideAvatar,
              isCenterAlignedEvenlySpaced,
              isCABReport,
              isCSBReport,
              PersonBonusIndicatorComponent,
              tierName,
              tabsValue,
              isViewTeam,
              viewTeamsData,
              lastPaidRank,
              reportData,
              downlineCoachIds,
              filtersData,
              reportParams,
              resetMyTeamsData,
              fetchReport,
              coachHighestRank,
              coachCurrentRank,
              count,
              reportMeta,
              loadMore,
              coachId,
              previousScreenName: prevScreen,
              currentScreenName: currentScreen,
              onFocus: (index: number) => this.scrollToIndex(index),
              renderNameElementDirectly,
              renderRoleElementDirectly,
            })}
            onMomentumScrollBegin={() => {
              if (Platform.OS !== 'web') {
                this.onEndReachedCalledDuringMomentum = false;
              }
            }}
            onEndReached={() => {
              const isWeb = Platform.OS === 'web';

              if (isViewTeam || isRefreshing || reportIsLoading) return;

              // Web: no momentum guard
              if (isWeb) {
                fetchMoreReport();
                return;
              }

              // Mobile: keep existing momentum logic
              if (!this.onEndReachedCalledDuringMomentum) {
                this.onEndReachedCalledDuringMomentum = true;
                fetchMoreReport();
              }
            }}
            ListFooterComponent={
              <Footer
                reportName={reportName}
                reportParams={reportParams}
                filtersData={filtersData}
                reportMeta={reportMeta}
                loadingData={loadMore || loadingData}
                reportData={reportData}
                reportIsLoading={reportIsLoading && !isViewTeam}
              />
            }
          />
        ) : tabsValue === 'watchlist' && downlineCoachIds.length === 0 ? (
          <WatchlistEmptyState />
        ) : tabsValue === 'watchlist' &&
          downlineCoachIds.length > 0 &&
          isEmpty(getFlatListData()) ? (
          reportIsLoading || isRefreshing ? (
            <ReportDefaultLoading {...loadingData} />
          ) : (
            <ReportEmptyState />
          )
        ) : (
          <ReportEmptyState />
        )}
      </View>
    );
  }
}

export default connect(mapStateToProps)(PeopleReportDataRenderer);
